import IClaimWhitespace from "interfaces/responses/IClaimWhitespace";
import { GlobalState } from "little-state-machine";

export const updateCurrentWhitespaceClaimsRoles = (state: GlobalState, currentWhitespaceClaimsRoles: IClaimWhitespace[]) => ({
  ...state,
  currentWhitespaceClaimsRoles
});
